module.exports = __webpack_public_path__ + "img/goal-symbol.68a05200.svg";